const getDefaultWindow = () => (typeof window !== 'undefined' ? window : null);

const getWindowConfig = (configName, windowObject = getDefaultWindow()) => {
  try {
    return windowObject?.[configName] || {};
  } catch (_) {
    return {};
  }
};

const hasConfigValues = (config = {}) =>
  Boolean(config && typeof config === 'object' && Object.keys(config).length);

const getWebpackInjectedAppConfig = () => {
  try {
    return typeof window !== 'undefined' ? window.appConfig || {} : {};
  } catch (_) {
    return {};
  }
};

const getGlobalConfig = (windowObject = getDefaultWindow()) =>
  getWindowConfig('globalConfig', windowObject);

const getAppConfig = (windowObject = getDefaultWindow()) => {
  const dynamicConfig = getWindowConfig('appConfig', windowObject);

  if (hasConfigValues(dynamicConfig) || windowObject !== getDefaultWindow()) {
    return dynamicConfig;
  }

  return getWebpackInjectedAppConfig();
};

const getOtelloConfig = (windowObject = getDefaultWindow()) =>
  getWindowConfig('otelloConfig', windowObject);

const getGlobalConfigValue = (
  key,
  fallback = undefined,
  windowObject = getDefaultWindow()
) => getGlobalConfig(windowObject)?.[key] ?? fallback;

const getAppConfigValue = (
  key,
  fallback = undefined,
  windowObject = getDefaultWindow()
) => getAppConfig(windowObject)?.[key] ?? fallback;

const getOtelloConfigValue = (
  key,
  fallback = undefined,
  windowObject = getDefaultWindow()
) => getOtelloConfig(windowObject)?.[key] ?? fallback;

export {
  getAppConfig,
  getAppConfigValue,
  getGlobalConfig,
  getGlobalConfigValue,
  getOtelloConfig,
  getOtelloConfigValue,
  getWindowConfig,
};
